
export default {
  data: function () {
    return {};
  },
  components: {},
  methods: {}
};
